import * as actionTypes from "./actionTypes";
import {firebase} from "../../firebase/index";
import {collections} from "../../firebase/firestoreNameSpaces";
import {generateUniqueId} from "../utility"
export const createAddress = (address,user) => {
  
  let userId = user.userId; 
  // console.log(userId)
  return dispatch=>{
    return new Promise((resolve,reject)=>{

      let addId = generateUniqueId()
      address["id"] = addId;
      let db = firebase.firestore();
     db.collection(collections.USERS).doc(user.userId).set({addresses:{ [addId]:address}},{merge:true}) 
     .then(()=>{

        if(Object.keys(user.addresses).length){
          let addresses = {...user.addresses}
          addresses[addId] = address;
          user.addresses = addresses;
          dispatch({type:actionTypes.SET_USER,payload:{user:user}})
        }else{
          user.addresses = {[addId]:address}
          dispatch({type:actionTypes.SET_CART_ORDER,payload:{address:address}})
        }

       
        resolve(true)
    }).catch(error=>{
      console.log(error)
      reject(error)
    })
   
  
    })
  }
   
};

export const selectAddress = (address)=>{
 
  return dispatch =>{
    return new Promise((resolve,reject)=>{

      dispatch({type:actionTypes.SET_CART_ORDER,payload:{address:address}})
      resolve(true)
    })
  }
}

export const deleteAddress = (id,user) => {

  let userId = user.userId;
   return  dispatch=>{

    return new Promise(async (resolve,reject)=>{

        try{

          let db = firebase.firestore();
          await db.collection(collections.USERS).doc(userId)
          .set(
          {
            addresses:{
              [id]:firebase.firestore.FieldValue.delete()
            }
          },{merge:true}
          )
          let addresses = {...user.addresses}
          delete addresses[id] 
          user.addresses = addresses;
          dispatch({type:actionTypes.SET_USER,payload:{user:user}})
          return resolve(true)
        }catch(error){

          return reject(error)
        }
    })
      
   }

    
  
}; 

export const editAddress = (address,user)=>{

  let userId = user.userId;
  return dispatch=>{
    return new Promise((resolve,reject)=>{

      let addId = address.id;
      let db = firebase.firestore();
     db.collection(collections.USERS).doc(userId).set({addresses:{ [addId]:address}},{merge:true}) 
     .then(()=>{

          let addresses = {...user.addresses}
          addresses[addId] = address;
          user.addresses = addresses;
          dispatch({type:actionTypes.SET_USER,payload:{user:user}})
        
        resolve(true)
    }).catch(error=>{
      reject(error)
    })
   
  
    })
  }

}
export const fetchAddress = (userId) => { 
  
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_ADDRESS,
      payload: { loading: true },
    });
   let db = firebase.firestore();
   db.collection(collections.USERS).doc(userId)
   .onSnapshot(snapshot=>{
    if(snapshot.exists){
      let data =snapshot.data().addresses;
      if(data){
        let fetchedAddress = [];
        for(let addId in data){ 
          fetchedAddress.push(data[addId])
        }
        fetchedAddress.sort((a,b) => (a.username > b.username) ? 1 : ((b.username > a.username) ? -1 : 0)); 
        dispatch({
          type: actionTypes.FETCH_ADDRESS,
          payload: { loading: false, userAddress: fetchedAddress },
        });
      }else{
        dispatch({
          type: actionTypes.FETCH_ADDRESS,
          payload: { loading: false, userAddress: [] },
        });
      } 
     
    }else{
      dispatch({
        type: actionTypes.FETCH_ADDRESS,
        payload: { loading: false, userAddress: [] },
      });
    }
   },err=>{
      dispatch({
        type: actionTypes.FETCH_ADDRESS,
        payload: { loading: false, userAddress: [] },
      });
   }
   )

   
  
  };
};